import { Outlet, useLocation } from 'react-router-dom'
import { BookOpenIcon, PlusIcon } from 'lucide-react'
import BrandLogo from '@/components/BrandLogo'
import UserDropdown from './modules/UserDropdown'
import HelpDropdown from './modules/HelpDropdown'
import { useRouter } from '@/router/hooks'
import { cn } from '@/utils'
import { useLayoutSettings } from '@/stores/layoutSettingStore'
import { useMediaQuery } from '@/hooks/useMediaQuery'
import { PAPERS_PATH } from '@/constants/routes'

const DefaultLayout = () => {
  const router = useRouter()
  const { pathname } = useLocation()
  const { themeMode } = useLayoutSettings()
  /** 与 .thesis-sidebar 断点一致 */
  const wide = useMediaQuery('(min-width: 960px)')
  const onLibrary = pathname === PAPERS_PATH || pathname === '/' || pathname === '/novels'

  return (
    <div className="thesis-app" data-page="thesis-shell" data-theme={themeMode}>
      <div className="thesis-app__frame">
        <aside className="thesis-sidebar" aria-label="主导航">
          {wide && <BrandLogo onClick={() => router.push(PAPERS_PATH)} />}
          <nav className="thesis-sidebar__nav">
            <button
              type="button"
              className={cn('thesis-nav-item', onLibrary && 'is-active')}
              onClick={() => router.push(PAPERS_PATH)}
            >
              <BookOpenIcon size={18} />
              我的论文
            </button>
            <button
              type="button"
              className="thesis-nav-item thesis-nav-item--create"
              onClick={() => router.push(`${PAPERS_PATH}/create`)}
            >
              <PlusIcon size={18} />
              新建论文
            </button>
          </nav>
          <div className="thesis-sidebar__foot">
            辅助写作，不是代写。
            <br />
            引用与数据请本人核实。
          </div>
        </aside>

        <div className="thesis-main">
          <header className="thesis-topbar">
            {/* 左：字标；点 logo 回论文库，小屏不再塞「论文库」文字链 */}
            <div className="thesis-topbar__start">
              {!wide && (
                <BrandLogo
                  className="thesis-topbar__logo"
                  onClick={() => router.push(PAPERS_PATH)}
                />
              )}
            </div>

            <div className="thesis-topbar__end">
              {!wide && (
                <button
                  type="button"
                  className="thesis-topbar-cta"
                  onClick={() => router.push(`${PAPERS_PATH}/create`)}
                >
                  新建
                </button>
              )}
              <HelpDropdown type="text" shape="circle" />
              <UserDropdown placement="bottomRight" />
            </div>
          </header>

          <main className="thesis-content">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  )
}

export default DefaultLayout
